import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import '../assets/css/admincustom.css';
import logo from '../assets/Images/logo.png';

function AdminSidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  const toggleSidebar = () => setIsOpen(!isOpen);

  useEffect(() => {
    const handleResize = () => {
      const isNowDesktop = window.innerWidth >= 768;
      setIsDesktop(isNowDesktop);
      if (isNowDesktop) setIsOpen(true);
      else setIsOpen(false);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/* Topbar for mobile only */}
      {!isDesktop && (
        <div className="admin-topbar">
          <h2>Admin Panel</h2>
          <button className="menu-btn" onClick={toggleSidebar}>☰</button>
        </div>
      )}
      <div className={`admin-sidebar bg-dark ${isDesktop ? "desktop" : "mobile"} ${isOpen ? "show" : ""}`}>
        
        <div className="text-center pb-3">
            <Link className="navbar-brand" to="/">
                <img src={logo} alt="Ezio Logo" style={{ height: '50px' }} />
            </Link>
            <h6 style={{color:"#6da146"}}>Ezio Infotech Pvt. Ltd.</h6>
        </div>
        <ul className="p-0">
          <li className="menuLi py-2 ps-2 d-flex gap-4"><Link className="text-decoration-none w-100" to="/admin/dashboard">Dashboard</Link></li>
          <li className="menuLi py-2 ps-2 d-flex gap-4"><Link className="text-decoration-none w-100" to="/admin/service">Services</Link></li>
          <li className="menuLi py-2 ps-2 d-flex gap-4"><Link className="text-decoration-none w-100" to="/admin/product">Products</Link></li>
          <li className="menuLi py-2 ps-2 d-flex gap-4"><Link className="text-decoration-none w-100" to="/admin/work">Works</Link></li>
          <li className="menuLi py-2 ps-2 d-flex gap-4"><Link className="text-decoration-none w-100" to="/admin/clientReview">Client Reviews</Link></li>
          <li className="menuLi py-2 ps-2 d-flex gap-4"><Link className="text-decoration-none w-100" to="/admin/carrer">Carrer</Link></li>
          <li className="menuLi py-2 ps-2 d-flex gap-4"><Link className="text-decoration-none w-100" to="/admin/application">Applications</Link></li>
          <li className="menuLi py-2 ps-2 d-flex gap-4"><Link className="text-decoration-none w-100" to="/admin/userContacts">User Contacts</Link></li>
          <li className="menuLi py-2 ps-2 d-flex gap-4"><Link className="text-decoration-none w-100" to="/admin/team">Teams</Link></li>
          <li className="menuLi py-2 ps-2 d-flex gap-4"><Link className="text-decoration-none w-100" to="/admin/groupImg">Group Image</Link></li>
          <li className="menuLi py-2 ps-2 d-flex gap-4"><Link className="text-decoration-none w-100" to="/admin/blogs">Blogs</Link></li>
          <li className="menuLi py-2 ps-2 d-flex gap-4"><Link className="text-decoration-none w-100" to="/admin/adminAccess">Admin Access</Link></li>
          <li className="menuLi py-2 ps-2 d-flex gap-4">
            <Link className="text-decoration-none w-100" to="/admin/logout">Logout</Link>
          </li>
        </ul>
      </div>
    </>
  );
}

export default AdminSidebar;
